import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import chatService from '../../services/chat.service';
import { toast } from 'react-toastify';
import config from '../../config';
import { NotifyMessage } from '../../components/NotifyMessage';

export function MeetOpenChat({ recipientId, count = 0, minCount = 25 }) {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  // срабатывает на первом свайпе и далее на каждом кратном minCount (25, 50, 75, ...),
  // на следующем свайпе плашка скрывается сама, поэтому сброс счётчика не нужен
  const shouldShowNotify = count > 0 && (count === 1 || count % minCount === 0);

  const handleToFindOrCreateChat = async () => {
    if (!recipientId) return;
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, recipientId);
      navigate(config.ROUTES.CHATS.TEXT(res.data._id), {
        state: {
          disabled: true
        }
      });
    } catch (error) {
      console.error('[Roulette] getChatToUserId:', error);
      toast.error('Ошибка при попытке открыть чат с пользователем');
    }
  };

  return (
    <>
      <button className="size-[48px] relative" onClick={handleToFindOrCreateChat}>
        <img className="w-full h-full" src="/icons/instr4.svg" alt="Открыть подарок" />
        {shouldShowNotify && (
          <NotifyMessage className="w-[270px] max-h-20" showMode={true} arrowPosition="right">
            <p onClick={handleToFindOrCreateChat}>
              Вы уверены в своих силах и не хотите дожидаться симпатии?
              <span className="text-[#A1F69E]"> Напишите первым за подарок</span>
            </p>
          </NotifyMessage>
        )}
      </button>
    </>
  );
}
